import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const tagImporterSelectors = importerSelectors(
  'tag.importer',
);

export default tagImporterSelectors;
